Ol = {
    init: function(){

        $('ol').each(function(idx, el) {
          var index = parseInt($(el).attr("start"))-1;
            if (!isNaN(index)) {
                $(el).css({'counter-reset':'li ' + index});    
            }
        });
    }
}